<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import { RouterLink } from 'vue-router';

export interface Props {
  label?: string;
  sublabel?: string;
  meta?: string;
  to?: RouteLocationRaw;
}
const props = withDefaults(defineProps<Props>(), {
  label: undefined,
  sublabel: undefined,
  meta: undefined,
  to: undefined,
});
</script>

<template>
  <component
    :is="props.to ? RouterLink : 'div'"
    :to="props.to"
    :class="$style.jobBookingRecentPanelItem"
    data-testid="jobBookingRecentPanelItem"
  >
    <span :class="$style.label">{{ props.label ?? '—' }}</span>
    <div v-if="props.sublabel || props.meta" :class="$style.bottom">
      <span v-if="props.sublabel" :class="$style.sublabel">{{
        props.sublabel
      }}</span>
      <span v-if="props.meta" :class="$style.meta">{{ props.meta }}</span>
    </div>
  </component>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.jobBookingRecentPanelItem {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid colors.$color-gray-200;
  text-decoration: none;
  &:last-child {
    border-bottom: none;
  }
  &:is(a):hover {
    background-color: colors.$color-gray-100;
  }
}
  .label {
    font-size: 0.9375rem;
    font-weight: 600;
    color: colors.$color-text-primary;
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }
  .sublabel {
    font-size: 0.8125rem;
    color: colors.$color-text-tertiary;
  }
  .meta {
    font-size: 0.8125rem;
    color: colors.$color-text-tertiary;
    text-align: right;
    white-space: nowrap;
  }
</style>
